import { ReactNode } from 'react';
import { LucideIcon } from 'lucide-react';

interface SplitFeatureProps {
  icon?: LucideIcon;
  eyebrow?: string;
  title: ReactNode;
  description: string;
  graphic: ReactNode;
  reverse?: boolean;
  tint?: boolean;
}

const SplitFeature = ({ icon: Icon, eyebrow, title, description, graphic, reverse = false, tint = false }: SplitFeatureProps) => {
  return (
    <section className={tint ? 'bg-primary-50/40' : 'bg-white'}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-8 md:py-10">
        <div className="grid md:grid-cols-2 border border-slate-200 overflow-hidden bg-white">
          <div className={`p-10 md:p-14 flex flex-col justify-center ${reverse ? 'md:order-2' : ''}`}>
            {Icon && (
              <div className="w-11 h-11 bg-primary-50 flex items-center justify-center mb-6">
                <Icon className="w-5 h-5 text-primary-700" />
              </div>
            )}
            {eyebrow && (
              <div className="text-xs font-semibold uppercase tracking-[0.14em] text-primary-600 mb-3">{eyebrow}</div>
            )}
            <h2 className="text-2xl md:text-3xl font-serif font-medium text-slate-900 leading-tight mb-4">{title}</h2>
            <p className="text-base text-slate-600 leading-relaxed">{description}</p>
          </div>

          <div className={`relative min-h-[280px] md:min-h-full ${reverse ? 'md:order-1' : ''}`}>
            {graphic}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SplitFeature;
